'use client';

import { startTransition, useCallback } from 'react';
import { useRouter } from 'next/navigation';
import type { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { useLocalizedPageUrlDispatch } from '../../providers/LocalizedPageUrlProvider/useLocalizedPageUrl';
import { usePageTransitionDispatch } from '../../providers/PageTransitionProvider/usePageTransition';

export function useRouterPush() {
  const router = useRouter();
  const setUrl = useLocalizedPageUrlDispatch();
  const setPageLoading = usePageTransitionDispatch();

  const push = useCallback(
    (href: string, options?: NavigateOptions) => {
      setUrl(href);
      setPageLoading(true);
      startTransition(() => {
        router.push(href, options);
        setPageLoading(false);
      });
    },
    [router, setUrl, setPageLoading],
  );

  return push;
}
